/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
export default props =>
  props.external ? (
    <a
      href={props.link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        variant: "typography.link",
        color: "inherit",
        "&.active": {
          color: "primary",
          ...props.hoverStyles,
        },
        "&:hover": {
          color: "purple",
          ...props.hoverStyles,
        },
        ...props.style,
      }}
      onClick={e => {
        e.stopPropagation()
      }}
      {...props}
    >
      {props.children}
    </a>
  ) : props.to.startsWith("#") ? (
    <a
      href={props.to}
      sx={{
        variant: "typography.link",
        color: "inherit",
        "&.active": {
          color: "primary",
          ...props.hoverStyles,
        },
        "&:hover": {
          color: "purple",
          ...props.hoverStyles,
        },
        ...props.style,
      }}
      onClick={e => {
        e.stopPropagation()
      }}
      {...props}
    />
  ) : (
    <Link
      {...props}
      activeClassName="active"
      sx={{
        variant: "typography.link",
        color: "inherit",
        "&.active": {
          color: "primary",
          ...props.hoverStyles,
        },
        "&:hover": {
          color: "purple",
          ...props.hoverStyles,
        },
        ...props.style,
      }}
    />
  )
